export enum TipoPrecipitacao {
	ACUMULADA = 'Acumulada',
	MEDIA = 'Média',
	DESVIO = 'Desvio',
}
